'use client';

import { BriefingCard, type BriefingSection } from './briefing-card';

// ---------------------------------------------------------------------------
// BriefingTileView — renders each section as a separate Card
// ---------------------------------------------------------------------------

interface BriefingTileViewProps {
  sections: BriefingSection[];
}

export function BriefingTileView({ sections }: BriefingTileViewProps) {
  return (
    <div className="space-y-6">
      {sections.map((section) => (
        <BriefingCard key={section.index} section={section} />
      ))}
    </div>
  );
}
